import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import {FormControl} from 'react-bootstrap';

import { customerGroupProjectSorter } from '../utils/sorting';
import * as list from '../utils/list';

import customerGroupActions from '../actions/customerGroupActionCreators';
import CustomerGroupProjectPill from './CustomerGroupProjectPill';
import AutoCustomerGroupInput from './AutoCustomerGroupInput';

require.ensure([], () => {
    require('./PMOProjectListWidget.less');
});

class CustomerGroupProjectWidget extends React.Component {

     constructor(props, context) {
        super(props, context);

        let currentYear = new Date().getFullYear();
        let years = [];
        let projectCreatedAt = currentYear;
        if(this.props.project.createdAt) {
            let createdAt = this.props.project.createdAt;
            projectCreatedAt = parseInt(createdAt.split('-')[0]);
        }
        for (let i = projectCreatedAt; i < projectCreatedAt + 8; i++) {
            years.push(i);
        }

        this.state = {
            active: this.props.active,
            error: false,
            customerGroup: "",
            customerGroupProjects: [],
            newlyAssigned: [],
            selectedCustomerGroup: null,
            toRemove: [],
            year: projectCreatedAt,
            years: years
        };
    }

    componentWillMount = () => {
        this.props.dispatch(customerGroupActions.loadAll());
        this.props.dispatch(customerGroupActions.loadByProject(this.props.project.id));
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({ customerGroupProjects: nextProps.customerGroupProjects })

        if(nextProps.newlyAssigned.length === 0)
            this.setState({ newlyAssigned: [] });
    }

    handleClick = () => {
        this.setState({ active: !this.state.active});
    }

    handleYearChange = (e) => {
        this.setState({year: e.target.value});
    }

    handleAddCustomerGroup = () => {
        if(this.state.customerGroup === null || this.state.customerGroup === "") return;

        let customerGroup = {
            id: null,
            name: this.state.customerGroup
        }
        this.props.dispatch(customerGroupActions.save(customerGroup));
        this.setState({ customerGroup: "" })
    }

    handleAddCustomerGroupProject = () => {
        let customerGroup = this.state.selectedCustomerGroup;
        let project = this.props.project;
        let year = parseInt(this.state.year);
        let newlyAssigned = this.state.newlyAssigned;

        if(customerGroup === null || year === "") return;

        for(let i = 0; i < newlyAssigned.length; i++) {
            if(newlyAssigned[i].year === year) {
                this.setState({error: true});
                return;
            }
        }

        const cgpList = this.props.customerGroupProjects;
        for(let i = 0; i < cgpList.length; i++) {
            if(cgpList[i].year === year) {
                this.setState({error: true});
                return;
            }
        }

        let customerGroupProject = {
            id: null,
            customerGroup,
            project,
            year
        };

        newlyAssigned.push(customerGroupProject);

        this.setState({
            newlyAssigned,
            selectedCustomerGroup: null
        });

        this.props.addCustomerGroupProject(customerGroupProject);
        this.setState({error: false});
    }

    handleCustomerGroupChange = () => {
        this.setState({
            selectedCustomerGroup: null,
        });
    }

    handleCustomerGroupClick = (payload) => {
        this.setState({
            selectedCustomerGroup: payload,
        });
    }

    removeExisting = (customerGroupProject) => {
        let customerGroupProjects = this.state.customerGroupProjects;
        let index = customerGroupProjects.indexOf(customerGroupProject);

        customerGroupProjects.splice(index, 1);

        this.setState({ customerGroupProjects });

        this.props.removeExisting(customerGroupProject);
    }

    removeNewlyAssigned = (customerGroupProject) => {
        let newlyAssigned = this.state.newlyAssigned;
        let index = newlyAssigned.indexOf(customerGroupProject);

        newlyAssigned.splice(index, 1);

        this.setState({ newlyAssigned });

        this.props.removeNewlyAssigned(customerGroupProject);
    }

    setCustomerGroup = (e) => {
        this.setState({ customerGroup: e.target.value });
    }

    render = () => {

        if (this.state.active) {
            return(
                <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                    <div className="form-horizontal">
                    <div className="panel panel-default panel-pmtask">
                        <div className="panel-heading" role="tab" id="headingOne">
                            <h4 style={{wordWrap : "break-word"}} className="panel-title">
                                <a onClick={this.handleClick} style={{"cursor" : "pointer"}} data-toggle="collapse" aria-expanded="true" aria-controls="collapseOne">
                                     <span className="md-expand-more" style={{textTransform: "none"}}/>
                                    {
                                        <span style={{textTransform: "none"}}> Customer Groups by year </span>
                                    }
                                </a>
                            </h4>
                            <div className="addCustomerGroup">
                                <span className="col-xs-10">
                                    <input value={this.state.customerGroup} onChange={this.setCustomerGroup} type="text" className="form-control" id="ex1" placeholder="Add New Customer Group" />
                                </span>
                                <button type="button" className="btn" onClick={this.handleAddCustomerGroup} >
                                    Add
                                </button>
                            </div>
                        </div><br/>
                        <div id="collapseOne" className="panel-collapse" role="tabpanel" aria-labelledby="headingOne">
                            <div className="panel-body">
                                <div className="form-group">
                                    <table className="table table-condensed project-people">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th className="text-center">Year</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tfoot>
                                            <tr>
                                            </tr>
                                        </tfoot>
                                        <tbody>
                                            {
                                                this.props.customerGroupProjects.map((customerGroupProject, i) => {
                                                    return <CustomerGroupProjectPill
                                                                handleRemove={this.removeExisting}
                                                                index={i}
                                                                customerGroupProject={customerGroupProject}
                                                                key={i}
                                                            />;
                                                    })
                                            }

                                            {
                                                this.state.newlyAssigned.map((customerGroupProject, i) => {
                                                    return <CustomerGroupProjectPill
                                                                handleRemove={this.removeNewlyAssigned}
                                                                index={i}
                                                                customerGroupProject={customerGroupProject}
                                                                key={i}
                                                                selectedCustomerGroup={this.state.selectedCustomerGroup}
                                                                newlyAssigned = {true}
                                                            />;
                                                    })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{marginLeft: "-15px", marginRight: "-15px"}}>
                                  <div className={this.state.error ? "col-md-7 has-error" : "col-md-7"} style={{paddingRight: 0}}>
                                    <div>
                                      <AutoCustomerGroupInput
                                        defaultText={this.state.selectedCustomerGroup ? this.state.selectedCustomerGroup.name : ""}
                                        enableClear
                                        handleFunction={this.handleCustomerGroupClick}
                                        handleTextChange={this.handleCustomerGroupChange}
                                        keepAfterClick
                                        ref="customerGroupPicker"
                                        selectedCustomerGroup={this.state.selectedCustomerGroup}
                                      />
                                    </div>
                                  </div>
                                  <div className={this.state.error ? "col-md-3 has-error" : "col-md-3"} style={{paddingRight: 0}}>
                                    <FormControl componentClass="select" onChange={this.handleYearChange}>
                                      {
                                        this.state.years.map((year, i) => {
                                          return <option key={i} value={year}>{year}</option>
                                        })
                                      }
                                    </FormControl>

                                  </div>
                                  <div style={{"marginLeft" : "5px"}} className="col-md-1 md-offset-1">
                                    <button type="button" title="Add customer group to project" onClick={this.handleAddCustomerGroupProject} style={{"background" : "transparent" , "border" : "none"}}>
                                      <a className="icon-btn">
                                            <span>
                                                <span className="md-done"></span>
                                            </span>
                                      </a>
                                    </button>
                                  </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                    <div className="panel panel-default panel-pmtask">
                        <div className="panel-heading" role="tab" id="headingOne">
                            <h4 style={{wordWrap : "break-word"}} className="panel-title">
                                <a onClick={this.handleClick} style={{"cursor" : "pointer"}} data-toggle="collapse" aria-expanded="true" aria-controls="collapseOne">
                                    <span className="md-chevron-right"></span>
                                    {
                                        <span style={{textTransform: "none"}}> Customer Groups by year </span>
                                    }
                                </a>
                            </h4>
                        </div>
                    </div>
                </div>
            );
        }
    }

}

const mapStateToProps = (state) => {
    let customerGroupProjects  = JSON.parse(JSON.stringify(state.customerGroups.customerGroupProjects));
    customerGroupProjects.sort(customerGroupProjectSorter);

    return {
        active: state.customerGroups.active,
        customerGroupProjects: customerGroupProjects
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomerGroupProjectWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/CustomerGroupProjectWidget.js
 **/